<template>
  <AuthFailure>
    <template #textSlot>
      <h2 style='max-width:420px'>Ваша учетная запись<br />заблокирована</h2>
    </template>
  </AuthFailure>
</template>

<script>
import AuthFailure from '../../components/auth-failure/AuthFailure.vue';

export default {
  name: 'BlockedUser',
  components: { AuthFailure },
  metaInfo() {
    return {
      title: `Доступ к данному ресурсу ограничен - ЛУКМАРКЕТ`,
    }
  },
}
</script>

<style></style>
